<template>
  <div class="product-content-fi">
    <headline-fi
      v-if="isLG"
      class="product-content-fi__headline"
      tag="div"
      :size="21"
    >
      {{ $dict.get('product-List.Table.Attribute-Content') }}
    </headline-fi>

    <grid-container-fi :container="false">
      <div class="product-content-fi__table-container">
        <technical-details-table-fi
          :item
          :attributes="attributes"
        />
      </div>

      <div
        v-if="productLineDrawing"
        class="product-content-fi__media-container"
      >
        <cloud-image-fi
          :src="productLineDrawing"
          class="product-content-fi__image"
          alt=""
          width="400"
          do-not-replace-url
        />
      </div>
    </grid-container-fi>
  </div>
</template>

<script setup lang="ts">
import { CloudImageFi, HeadlineFi } from 'atoms';
import { computed } from 'vue';

import GridContainerFi from '@/components/grid-fi/GridContainerFi.vue';
import TechnicalDetailsTableFi from '@/components/shop-modules/technical-details-table-fi/TechnicalDetailsTableFi.vue';
import { useBreakpoints } from '@/composables/breakpoint';
import type { SearchProductsForFamilyNgQuery } from '@/generated/graphql';

export type CatalogProductData = NonNullable<
  NonNullable<
    NonNullable<
      NonNullable<
        NonNullable<SearchProductsForFamilyNgQuery['searchProductsForFamilyNg']>['hits']
      >[number]
    >['variantValuesObject']
  >[number]
>;

defineOptions({ name: 'ProductContentFi' });

const props = withDefaults(
  defineProps<{
    item?: CatalogProductData | null;
    attributes: any[];
    familyLineDrawing?: string | null;
  }>(),
  {
    item: null,
    familyLineDrawing: null,
  },
);

const { isLG } = useBreakpoints();

const productLineDrawing = computed(
  () => props.item?.catalogProductData?.productLineDrawing || props.familyLineDrawing,
);
</script>

<style scoped src="./product-content-fi" />
